import { FormControl, InputLabel, Select } from '@mui/material';
import PropTypes from 'prop-types';

ToolbarSelect.propTypes = {
  ...Select.propTypes,
  options: PropTypes.array,
  label: PropTypes.string,
};

export default function ToolbarSelect(props) {
  const { inputProps, label } = props;
  return (
    <FormControl variant="standard" size="small">
      <InputLabel
        htmlFor={`${inputProps.id}`}
        sx={{
          color: '#fff',
        }}
        shrink
      >
        {label}
      </InputLabel>
      <Select
        sx={{
          color: '#fff',
          ':before': {
            borderBottom: '1px solid rgba(255, 255, 255, 1) !important',
          },
          ':after': { borderBottomColor: '#fff' },
          '& .MuiSelect-icon': { color: '#fff' },
          '& .MuiSelect-select:focus': { backgroundColor: 'transparent' },
        }}
        {...props}
      />
    </FormControl>
  );
}
